import a1 from '../images/a1.jpg';
import a2 from '../images/a2.jpg';
import a3 from '../images/a3.jpg';
import a4 from '../images/a4.jpg';
import a5 from '../images/a5.jpg';
import a6 from '../images/a6.jpg';
import a7 from '../images/a7.jpg';
import a8 from '../images/a8.jpg';
import a9 from '../images/a9.jpg';
import a10 from '../images/a10.jpg';
import t1 from '../images/t1.jpg';
import t2 from '../images/t2.jpg';
import t3 from '../images/t3.jpg';
import t4 from '../images/t4.jpg';
import t5 from '../images/t5.jpg';
import t6 from '../images/t6.jpg';
import t7 from '../images/t7.jpg';
import t8 from '../images/t8.jpg';
import t9 from '../images/t9.jpg';
import t10 from '../images/t10.jpg';
import jnh1 from '../images/jnh1.jpg';
import jnh2 from '../images/jnh2.jpg';
import jnh3 from '../images/jnh3.jpg';
import jnh4 from '../images/jnh4.jpg';
import jnh5 from '../images/jnh5.jpg';
import jnh6 from '../images/jnh6.jpg';
import jnh7 from '../images/jnh7.jpg';
import jnh8 from '../images/jnh8.jpg';
import jnh9 from '../images/jnh9.jpg';
import jnh10 from '../images/jnh10.jpg';

export const items = [
  {
    image: jnh10,
    title: 'Rick and Morty Hoodie',
    info: 'Long-sleeved hoodie in soft sweatshirt fabric with a kangaroo pocket.',
    price: 2299,
    id: '#jnh1091831',
    category: 'Hoodies',
  },
  {
    image: jnh9,
    title: 'Relaxed Fit Zip-through Petrol hoodie',
    info: 'Zip-through hoodie in sweatshirt fabric',
    price: 1999,
    id: '#jnh2457457',
    category: 'Hoodies',
  },
  {
    image: jnh8,
    title: 'Snoopy printed sweatshirt',
    info: 'Top in sweatshirt fabric made from a cotton blend with a print motif. Round, rib-trimmed neckline, dropped shoulders, long sleeves and ribbing at the cuffs and hem. ',
    price: 2499,
    id: '#jnh2346544',
    category: 'Hoodies',
  },
  {
    image: jnh7,
    title: 'Dark green hooded',
    info: 'Top in sweatshirt fabric with a jersey-lined, drawstring hood with a wrapover front',
    price: 1299,
    id: '#jnh31645645',
    category: 'Hoodies',
  },
  {
    image: jnh6,
    title: 'Natural white printed sweatshirt',
    info: 'Embroidered motif on the front, a fabric appliqué on one sleeve and ribbing around the neckline, cuffs and hem. ',
    price: 1999,
    id: '#jnh403822',
    category: 'Hoodies',
  },
  {
    image: jnh5,
    title: 'Hooded denim jacket',
    info: 'Jacket in washed denim with a hood and sleeves in sweatshirt fabric. Collar, jersey-lined drawstring hood, buttons down the front, flap chest pockets with a button and side pockets. Ribbing at the cuffs, and an adjustable tab at the sides of the hem. Unlined.',
    price: 2999,
    id: '#jnh53049285',
    category: 'Hoodies',
  },
  {
    image: jnh4,
    title: 'Lightweight puffer jacket',
    info: 'Woven fabric with a hood and discreet zip down the front with a chin guard. Pockets in the side seams with a concealed zip',
    price: 2299,
    id: '#jnh62304722',
    category: 'Hoodies',
  },
  {
    image: jnh3,
    title: 'Biker jacket',
    info: 'Jacket in soft imitation leather with a zip down the front and small stand-up collar with a press-stud.',
    price: 4499,
    id: '#jnh72938233',
    category: 'Hoodies',
  },
  {
    image: jnh2,
    title: 'Corduroy shirt jacket',
    info: 'Shirt jacket in soft cotton corduroy with a collar, zip down the front and yoke at the back.',
    price: 2299,
    id: '#jnh823986233',
    category: 'Hoodies',
  },
  {
    image: jnh1,
    title: 'Faux shearling jacket',
    info: 'Jacket in soft faux shearling with a yoke in woven fabric.',
    price: 2999,
    id: '#jnh10067845221',
    category: 'Hoodies',
  },

  {
    image: t1,
    title: 'Black cargo joggers',
    info: 'Joggers in sweatshirt fabric made from a cotton blend with a soft brushed inside. Elasticated, drawstring waist, discreet side pockets and flap leg pockets with a hook and loop fastening. Tapered legs with ribbing at the hems.',
    price: 1499,
    id: '#t1091831',
    category: 'Trousers',
  },
  {
    image: t2,
    title: 'Beige Cargo Regular',
    info: 'Trousers in a cotton weave with a zip fly and button, diagonal side pockets and flap leg and back pockets with concealed press-studs. Concealed drawstring at the hems.',
    price: 2299,
    id: '#t2457457',
    category: 'Trousers',
  },
  {
    image: t3,
    title: 'Khaki green Cargo Regular',
    info: 'Trousers in a cotton weave with a zip fly and button, diagonal side pockets and flap leg and back pockets with concealed press-studs. Concealed drawstring at the hems. ',
    price: 2299,
    id: '#t1346544',
    category: 'Trousers',
  },
  {
    image: t4,
    title: 'Grey cargo joggers',
    info: 'Joggers in a cotton weave with covered elastication and a drawstring at the waist, diagonal side pockets and flap back and leg pockets with concealed press-studs. Tapered legs with seams and darts at the knees and covered elastication at the hems.',
    price: 2699,
    id: '#t1645645',
    category: 'Trousers',
  },
  {
    image: t5,
    title: 'Brown Slim Fit Chinos',
    info: 'Chinos in extra-stretchy cotton twill with a zip fly, side pockets, a coin pocket and welt back pockets with a button. Slim Fit – a fit that is close-fitting at the thighs, knees and ankles to create a fitted silhouette.',
    price: 1999,
    id: '#t1203822',
    category: 'Trousers',
  },
  {
    image: t6,
    title: 'Green Linen-mix trousers',
    info: 'Trousers in a linen and cotton weave with covered elastication and a drawstring at the waist. Zip fly and button, diagonal side pockets, welt back pockets with a button, and cropped, tapered legs. Regular Fit – a classic fit with good room for movement over the thighs and knees to create a comfortable, straight silhouette.',
    price: 1999,
    id: '#t13049285',
    category: 'Trousers',
  },
  {
    image: t7,
    title: 'Hybrid Blue Tapered Joggers',
    info: '5-pocket joggers in stretch denim. Regular waist with covered elastication and a drawstring, and a zip fly with a button. ',
    price: 2699,
    id: '#t12304722',
    category: 'Trousers',
  },
  {
    image: t8,
    title: 'Green Slim Fit Joggers',
    info: 'Joggers in sweatshirt fabric made from a cotton blend with a soft brushed inside. Elasticated, drawstring waist, a small text motif at the front, pockets in the side seams, a welt back pocket and covered elastication at the hems.',
    price: 1799,
    id: '#t12938233',
    category: 'Trousers',
  },
  {
    image: t9,
    title: 'Denim dungarees',
    info: 'Ankle-length dungaree in cotton denim with button at the sides and adjustable staps with metal fasteners.',
    price: 2999,
    id: '#t123986233',
    category: 'Trousers',
  },
  {
    image: t10,
    title: 'Grey marl Joggers',
    info: ' Covered elastication and a drawstring at the waist, pockets in the side seams and ribbed hems. Soft brushed inside.',
    price: 1499,
    id: '#t167845221',
    category: 'Trousers',
  },
  {
    image: a1,
    title: 'Roll-top backpack',
    info: 'Backpack in woven fabric with a handle and adjustable.',
    price: 1499,
    id: '#a1091831',
    category: 'Accessories',
  },
  {
    image: a2,
    title: 'Felted wool hat',
    info: 'Sturdy hat in felted wool with a band. Width of brim 6.5 cm.',
    price: 899,
    id: '#a2457457',
    category: 'Accessories',
  },
  {
    image: a3,
    title: 'Jersey hat',
    info: 'Double-layered hat in soft jersey.',
    price: 399,
    id: '#a1346544',
    category: 'Accessories',
  },
  {
    image: a4,
    title: 'Bucket hat',
    info: 'Sporty bucket hat in woven fabric with metal eyelets in the sides. Lined.',
    price: 699,
    id: '#a1645645',
    category: 'Accessories',
  },
  {
    image: a5,
    title: 'Sports cap',
    info: 'Sports cap with a woven front, mesh back and a sweatband. Adjustable plastic fastener and a small reflective print at the back.',
    price: 799,
    id: '#a1203822',
    category: 'Accessories',
  },
  {
    image: a6,
    title: '2-pack necklaces',
    info: 'Metal chain necklaces in different designs, one with a polished plastic stone pendant. Trigger clasp.',
    price: 999,
    id: '#a13049285',
    category: 'Accessories',
  },
  {
    image: a7,
    title: '3-pack rings',
    info: 'Metal rings in various designs.',
    price: 699,
    id: '#a12304722',
    category: 'Accessories',
  },
  {
    image: a8,
    title: 'Sunglasses',
    info: 'Sunglasses with plastic frames and tinted, UV-protective plastic lenses.',
    price: 799,
    id: '#a12938233',
    category: 'Accessories',
  },
  {
    image: a9,
    title: 'Flat cap',
    info: 'Flat cap in woven fabric. Lined.',
    price: 999,
    id: '#a123986233',
    category: 'Accessories',
  },
  {
    image: a10,
    title: 'Fine-knit hat',
    info: 'Double-layered hat in a soft, fine knit. Turn-up at the hem with a fabric appliqué on the front.',
    price: 499,
    id: '#a167845221',
    category: 'Accessories',
  },
];
